import References from '../../helpers/Reference';
import { useAuth, hydrateUserSettings, initializeUserSettings } from "./store";
import { useSubdomains } from '../Subdomains/store';
import { jwtDecode } from 'jwt-decode';
import { clearStationFilters } from '../../helpers/helpers';
import { getRestoredHolderFilterAreas } from './holderFilter.helper';
import { useStationFilter } from '../SearchStation/store';

export const InitAuth = () => {	
    AuthService.isAuth()
        .then(data => {
			const permission = jwtDecode(data.access);
			useAuth.setState({
				isAuth: true,
				permission: permission
			});
			try {
				const userId = permission?.user_id || permission?.user || permission?.id || permission?.sub || permission?.username || null;
				initializeUserSettings(userId);
			} catch (e) {
				console.warn('Failed to hydrate user settings during InitAuth', e);
			}
		}
		)
		.catch(() => useAuth.setState({isAuth: false}))
		.finally(() => useAuth.setState({isProcessing: false}));
}

function TokenException( message ) {
		this.message = message;		
}

export default class AuthService {

	static getHeaders = ( data ) => {
		return {
			    method: "POST",
			    headers: {
			      "Content-Type": "application/json"
			    },
			    body: JSON.stringify( data )

		}
	}

	static async login( login, password ) {	
/*		let login = 'debug';
		let password = 'AWs45-zx';*/
		let data = {"username": login, "password": password};
		return fetch(
			References.api.login, 
			AuthService.getHeaders( data )
		)
        .then( response => response.json())
	}

	static async afterLogon(data, callbackSuccess, callbackFail, paramSuccess, paramFail) {
		try {
		if (data.hasOwnProperty('access') && data.hasOwnProperty('refresh')) {
				if (callbackSuccess)
					callbackSuccess(paramSuccess);
				AuthService.successLogin(data);
			} else
				throw new Error('invalid auth');
		}
		catch(error) {                
			if (callbackFail)
				callbackFail(paramFail);
			AuthService.failLogin();
		}
		finally {
			useAuth.setState({isProcessing: false});
			// clear active filters then reapply saved holder areas if present
			clearStationFilters();
			try {
				const settings = useAuth.getState().userSettings;
				const restored = getRestoredHolderFilterAreas(settings);
				if (restored && restored.length > 0) {
					useStationFilter.setState({ areas: [...restored] });
				}
			} catch (e) {
				console.warn('Failed to restore holder filter after login', e);
			}
		};
			
	}

	static async successLogin( data ) {
		const permission = jwtDecode(data.access);
		useAuth.setState({
			isAuth: true,
			permission: permission,
			isAuthorized: false,
			isProcessing: true,
			authError: null
		});
		AuthService.saveTokens(data.access, data.refresh);
		try {
			// hydrate per-user settings from server GET and keep server-backed values off localStorage
			const userId = permission?.user_id || permission?.user || permission?.id || permission?.sub || permission?.username || null;
			initializeUserSettings(userId);
		} catch (e) {
			console.warn('Failed to hydrate user settings on login', e);
		}
	}

	static async failLogin() {
		useAuth.setState({
			isAuth: false,
			isAuthorized: false,
			authError: 'invalid_auth'
		});                
	}

	static async logout() {
		let data = {"refresh": localStorage.getItem('refresh_token')};
		fetch(
			References.api.logout, 
			AuthService.getHeaders( data )
		)
		.then(data => {
			useAuth.setState({isAuth: false});
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');	
			hydrateUserSettings();
		})
	}

	static async logoutAll() {
		let data = {"refresh": localStorage.getItem('refresh_token')};
		fetch(
			References.api.logout_all, 
			AuthService.getHeaders( data )
		)
		.then(data => {
			useAuth.setState({isAuth: false});
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');	
			hydrateUserSettings();
		})
	}


	static async saveTokens( access, refresh ) {
		localStorage.setItem('access_token', access);
		localStorage.setItem('refresh_token', refresh);
	}

	static isAuth() {
		return this.getAccessToken()
			.then( data => {					
				if (data.hasOwnProperty('code') && data.code != 'token_not_valid')
					throw new Error();
				return data;
			})
			.catch((data) => {
				return false
			});		
	}

	static async refresh() {
		let data = {"refresh": localStorage.getItem('refresh_token')};
		try {
			return fetch(
				References.api.refresh,
				AuthService.getHeaders( data )			
			)
			.then( response => response.json());			
			
		} catch (e) {
			console.log( e.message );
		}
	}

	static async check( token ) {		
		let data = {"token": localStorage.getItem( 'access_token' )};
		return fetch(
				References.api.check, 
				AuthService.getHeaders( data )
			)
		.then(response => response.json())
		.catch(response => console.log('checkk_auth'))
	}

	static async getAccessToken() {
		let access = localStorage.getItem( 'access_token' );
		let refresh = localStorage.getItem( 'refresh_token' );

		if (!access || !refresh)
			throw new Error('no_keys');			

		return this.check()
			.then( data => {
				if (!data)
					throw new Error('no_auth_data');
				if (data.hasOwnProperty('code') && data.code == 'token_not_valid')
					return AuthService.refresh();
				else {
					return {
						"access": localStorage.getItem('access_token')
					}
				}
			})
			.catch(response => console.log(response.message));
	}

	static fetch( url ) {
		return this.getAccessToken()
			.then( data => {	
					if (data.hasOwnProperty('access'))
						AuthService.saveTokens( data.access, localStorage.getItem('refresh_token') );

					return fetch( url, {
						"headers": {						
							"Authorization": "Bearer " + data.access
						}
					});
				}
			)
	}

}